import { useState } from 'react';
import { useCookies } from 'react-cookie';

import { THEME_MODE_COOKIE } from 'shared/constants/cookies';
import { ThemeModeEnum } from 'shared/enums/ThemeModeEnum';
import { prefersHighContrast } from 'shared/utils/prefersHighContrast';
import dayjs from 'dayjs';

export const useThemeModeCookie = () => {
  const [cookies, setCookie] = useCookies([THEME_MODE_COOKIE]);

  // Called only from the user's theme toggle, so always persist — including on the kiosk landing,
  // where the survey (and therefore the distribution) isn't loaded yet.
  const setThemeModeCookie = (themeMode: ThemeModeEnum) => {
    const expires = dayjs().add(1, 'year').toDate();
    setCookie(THEME_MODE_COOKIE, themeMode.toString(), { expires, sameSite: 'none', secure: true });
  };

  // Cookie choice wins; otherwise fall back to the accessible theme when the OS prefers high
  // contrast. Lazy initializer so it's resolved once per mount, not on every re-render.
  const [initialTheme] = useState<ThemeModeEnum>(
    () =>
      (cookies[THEME_MODE_COOKIE] as ThemeModeEnum) ||
      (prefersHighContrast() ? ThemeModeEnum.HIGH_CONTRAST_ACCESSIBLE : ThemeModeEnum.LIGHT)
  );

  return {
    setThemeModeCookie,
    initialTheme,
  };
};
